import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import SectionWrapper from '../../shared/SectionWrapper';
import {
  SectionTitle,
  SectionPrompt,
  SkillsGrid,
  SkillCategory,
  SkillCategoryTitle,
  SkillTags,
  SkillTag,
} from '../styles';

interface SkillsProps {
  themeName: ThemeType;
}

interface SkillCategoryData {
  name: string;
  items: string[];
}

const Skills: React.FC<SkillsProps> = ({ themeName }) => {
  const { t } = useTranslation();
  const categories = t('ClassicPage.skills.categories', { returnObjects: true }) as SkillCategoryData[];

  if (!Array.isArray(categories)) return null;

  return (
    <SectionWrapper id="skills" themeName={themeName}>
      <SectionPrompt $themeName={themeName}>$ ls skills/</SectionPrompt>
      <SectionTitle $themeName={themeName}>{t('ClassicPage.skills.title')}</SectionTitle>
      <SkillsGrid>
        {categories.map((cat, i) => (
          <SkillCategory key={i} $themeName={themeName}>
            <SkillCategoryTitle $themeName={themeName}>{cat.name}</SkillCategoryTitle>
            <SkillTags>
              {cat.items.map((item, j) => (
                <SkillTag key={j} $themeName={themeName}>{item}</SkillTag>
              ))}
            </SkillTags>
          </SkillCategory>
        ))}
      </SkillsGrid>
    </SectionWrapper>
  );
};

export default Skills;
